<template>
  <div>
    <ForgotPasswordForm />
  </div>
</template>

<script>
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";

export default {
  components: { ForgotPasswordForm },
};
</script>
